<template>
    <div>
        <b-tab title="Tab 6">
            <b-card-text>
                <h2>AMBIENTI DI LAVORO - principali adempimenti</h2>
                <h4>Segnaletica di sicurezza</h4>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-3">
                        Estintori:
                    </div>
                    <div class="form-group col-md-3">
                        <label for="estintori_presente"><input type="radio" value="estintori_presente" v-model="ambientiLavoro.estintori" style="margin-right:5px">Presente</label><br>
                    </div>
                    <div class="form-group col-md-3">
                    <label for="estintori_assente"><input type="radio" value="estintori_assente" v-model="ambientiLavoro.estintori" style="margin-right:5px">Assente</label><br>
                    </div>
                    <div class="form-group col-md-3">
                        <label for="estintori_integrare"><input type="radio" value="estintori_integrare" v-model="ambientiLavoro.estintori" style="margin-right:5px">Integrare</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-3">
                        Vie di fuga:
                    </div>
                    <div class="form-group col-md-3">
                        <label for="vie_fuga_presente"><input type="radio" value="vie_fuga_presente" v-model="ambientiLavoro.vie_fuga" style="margin-right:5px">Presente</label><br>
                    </div>
                    <div class="form-group col-md-3">
                    <label for="vie_fugai_assente"><input type="radio" value="vie_fuga_assente" v-model="ambientiLavoro.vie_fuga" style="margin-right:5px">Assente</label><br>
                    </div>
                    <div class="form-group col-md-3">
                        <label for="vie_fuga_integrare"><input type="radio" value="vie_fuga_integrare" v-model="ambientiLavoro.vie_fuga" style="margin-right:5px">Integrare</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-3">
                        Su macchine ed attrezzatura:
                    </div>
                    <div class="form-group col-md-3">
                        <label for="macchine_attrezzatura_presente"><input type="radio" value="macchine_attrezzatura_presente" v-model="ambientiLavoro.macchine_attrezzatura" style="margin-right:5px">Presente</label><br>
                    </div>
                    <div class="form-group col-md-3">
                    <label for="macchine_attrezzatura_assente"><input type="radio" value="macchine_attrezzatura_assente" v-model="ambientiLavoro.macchine_attrezzatura" style="margin-right:5px">Assente</label><br>
                    </div>
                    <div class="form-group col-md-3">
                        <label for="macchine_attrezzatura_integrare"><input type="radio" value="macchine_attrezzatura_integrare" v-model="ambientiLavoro.macchine_attrezzatura" style="margin-right:5px">Integrare</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-3">
                        Destinazione d'uso dei locali:
                    </div>
                    <div class="form-group col-md-3">
                        <label for="destinazione_uso_locale_presente"><input type="radio" value="destinazione_uso_locale_presente" v-model="ambientiLavoro.destinazione_uso_locale" style="margin-right:5px">Presente</label><br>
                    </div>
                    <div class="form-group col-md-3">
                    <label for="destinazione_uso_locale_assente"><input type="radio" value="destinazione_uso_locale_assente" v-model="ambientiLavoro.destinazione_uso_locale" style="margin-right:5px">Assente</label><br>
                    </div>
                    <div class="form-group col-md-3">
                        <label for="destinazione_uso_locale_integrare"><input type="radio" value="destinazione_uso_locale_integrare" v-model="ambientiLavoro.destinazione_uso_locale" style="margin-right:5px">Integrare</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-3">
                        Sui contenitori dei prodotti chimici:
                    </div>
                    <div class="form-group col-md-3">
                        <label for="contenitori_prodotti_chimici_presente"><input type="radio" value="contenitori_prodotti_chimici_presente" v-model="ambientiLavoro.contenitori_prodotti_chimici" style="margin-right:5px">Presente</label><br>
                    </div>
                    <div class="form-group col-md-3">
                    <label for="contenitori_prodotti_chimici_assente"><input type="radio" value="contenitori_prodotti_chimici_assente" v-model="ambientiLavoro.contenitori_prodotti_chimici" style="margin-right:5px">Assente</label><br>
                    </div>
                    <div class="form-group col-md-3">
                        <label for="contenitori_prodotti_chimici_integrare"><input type="radio" value="contenitori_prodotti_chimici_integrare" v-model="ambientiLavoro.contenitori_prodotti_chimici" style="margin-right:5px">Integrare</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-3">
                        Servizi igenici:
                    </div>
                    <div class="form-group col-md-3">
                        Divisi per sesso sopra le 10 unità
                        <div class="form-row justify-content-md-center">
                            <label class="switch"> <input type="checkbox" class="form-control" v-model="ambientiLavoro.servizi_igenici_divisi"><span class="slider round"></span></label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        Dotati di antibagno
                                <div class="form-row justify-content-md-center">
                                    <label class="switch"> <input type="checkbox" class="form-control" v-model="ambientiLavoro.servizi_igenici_antibagno"><span class="slider round"></span></label>
                                </div>
                    </div>
                    <div class="form-group col-md-3"></div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-3">
                        Aerazione naturale (finestre, lucernari, etc):
                    </div>
                    <div class="form-group col-md-3">
                        <label for="aerazione_naturale_presente"><input type="radio" value="aerazione_naturale_presente" v-model="ambientiLavoro.aerazione_naturale" style="margin-right:5px">Presente</label><br>
                    </div>
                    <div class="form-group col-md-3">
                    <label for="aerazione_naturale_assente"><input type="radio" value="aerazione_naturale_assente" v-model="ambientiLavoro.aerazione_naturale" style="margin-right:5px">Assente</label><br>
                    </div>
                    <div class="form-group col-md-3"></div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-3">
                        Illuminazione naturale:
                    </div>
                    <div class="form-group col-md-3">
                        <label for="illuminazione_presente"><input type="radio" value="illuminazione_presente" v-model="ambientiLavoro.illuminazione_naturale" style="margin-right:5px">Presente</label><br>
                    <label for="illuminazione_presente"><input type="radio" value="illuminazione_assente" v-model="ambientiLavoro.illuminazione_naturale" style="margin-right:5px">Assente</label><br>
                    <label for="illuminazione_naturale_assente"><input type="radio" value="illuminazione_naturale_assente" v-model="ambientiLavoro.illuminazione_naturale" style="margin-right:5px">Assente</label><br>
                    </div>
                    <div class="form-group col-md-3">
                        <label for="schermata_tendaggi"><input type="checkbox" v-model="ambientiLavoro.schermata_tendaggi" style="margin-right:5px">schermata con tendaggi</label><br>
                        <label for="schermata_veneziane"><input type="checkbox" v-model="ambientiLavoro.schermata_veneziane" style="margin-right:5px">schermata con veneziane</label>
                    </div>
                    <div class="form-group col-md-3">
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-3">
                        Illuminazione artificiale:
                    </div>
                    <div class="form-group col-md-3">
                        <label for="illuminazione_artificiale_presente"><input type="radio" value="illuminazione_artificiale_presente" v-model="ambientiLavoro.illuminazione_artificiale" style="margin-right:5px">Presente</label><br>
                    <label for="illuminazione_artificiale_assente"><input type="radio" value="illuminazione_artificiale_assente" v-model="ambientiLavoro.illuminazione_artificiale" style="margin-right:5px">Assente</label><br>
                    </div>
                    <div class="form-group col-md-3">
                        <label for="schermata_tendaggi">In ufficio: <input type="checkbox" v-model="ambientiLavoro.schermata_tendaggi" style="margin-right:5px">antiriflesso</label>
                    </div>
                    <div class="form-group col-md-3">
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-3">
                        Scale:
                    </div>
                    <div class="form-group col-md-3">
                        Parapetto h > 1m:
                        <div class="form-row justify-content-md-center">
                            <label class="switch"> <input type="checkbox" class="form-control" v-model="ambientiLavoro.scale_parapetto"><span class="slider round"></span></label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        Gradini antiscivolo:
                        <div class="form-row justify-content-md-center">
                            <label class="switch"> <input type="checkbox" class="form-control" v-model="ambientiLavoro.gradini_antiscivolo"><span class="slider round"></span></label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        Corrimano:<br>
                        <label for="corrimano_presente"><input type="radio" value="presente" v-model="ambientiLavoro.corrimano" style="margin-right:5px;">Presente</label>
                        <label for="corrimano_assente"><input type="radio" value="assente" v-model="ambientiLavoro.corrimano" style="margin-left:10px;margin-right:5px">Assente</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-3">
                        Scale portatili:
                    </div>
                    <div class="form-group col-md-3">
                        Praticabili:<br>
                        <label for="parapetto"><input type="checkbox" v-model="ambientiLavoro.parapetto" style="margin-right:5px">Parapetto</label><br>
                        <label for="indicazione_portata"><input type="checkbox" v-model="ambientiLavoro.indicazione_portata" style="margin-right:5px">indicazione portata</label><br>
                    </div>
                    <div class="form-group col-md-3">
                        <label for="scale_conformi_si"><input type="radio" value="si" v-model="ambientiLavoro.scale_conformi" style="margin-right:5px;">Si</label>
                        <label for="scale_conformi_no"><input type="radio" value="no" v-model="ambientiLavoro.scale_conformi" style="margin-left:10px;margin-right:5px">No</label> 
                    </div>
                    <div class="form-group col-md-3"></div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-3">
                        Soppalchi:
                    </div>
                    <div class="form-group col-md-3">
                        <label for="scale_conformi_si"><input type="radio" value="si" v-model="ambientiLavoro.scale_conformi" style="margin-right:5px;">Si</label>
                        <label for="scale_conformi_no"><input type="radio" value="no" v-model="ambientiLavoro.scale_conformi" style="margin-left:10px;margin-right:5px">No</label> 
                    </div>
                    <div class="form-group col-md-4">
                        <label for="presenza_scale">Non praticabili: <input type="checkbox" v-model="ambientiLavoro.presenza_scale" style="margin-right:5px;">Presenza di scale</label>
                    </div>
                    <div class="form-group col-md-2"></div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-3">
                        Scaffalature:
                    </div>
                    <div class="form-group col-md-3">
                        <label for="scaffalature"><input type="checkbox" value="si" v-model="ambientiLavoro.presenza_scale" style="margin-right:5px;">fissate a parete o pavimento</label>
                    </div>
                    <div class="form-group col-md-3">
                        <label for="indicazione_portata"><input type="checkbox" v-model="ambientiLavoro.indicazione_portata" style="margin-right:5px;">indicazione portata</label>
                        <label for="presenza_paracolpi_base"><input type="checkbox" v-model="ambientiLavoro.indicazione_portata" style="margin-right:5px;">presenza di paracolpi alla base</label>
                    </div>
                    <div class="form-group col-md-3"></div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-3">
                        Estintori:
                    </div>
                    <div class="form-group col-md-3">
                        <label for="numero_estintori">N.</label>
                        <input type="number" class="form-control" v-model="ambientiLavoro.numero_estintori">
                    </div>
                    <div class="form-group col-md-3">
                        Controllo semestrale<br>
                        <label for="controllo_semestrale_si"><input type="radio" value="si" v-model="ambientiLavoro.controllo_semestrale" style="margin-right:5px;">Si</label>
                        <label for="controllo_semestrale_no"><input type="radio" value="no" v-model="ambientiLavoro.controllo_semestrale" style="margin-left:10px;margin-right:5px">No</label> 
                    </div>
                    <div class="form-group col-md-3"></div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-3">
                        Cassetta P.S. Agg.ta e segnalata
                    </div>
                    <div class="form-group col-md-3">
                        <label for="cassetta_si"><input type="radio" value="si" v-model="ambientiLavoro.cassetta" style="margin-right:5px;">Si</label>
                        <label for="cassetta_no"><input type="radio" value="no" v-model="ambientiLavoro.cassetta" style="margin-left:10px;margin-right:5px">No</label> 
                    </div>
                    <div class="form-group col-md-3">
                    </div>
                    <div class="form-group col-md-3"></div>
                </div>
            </b-card-text>
        </b-tab>  
            <!-- <button class="btn float-right" type="button" v-on:click="salvaValoriIdentificazione()" style="margin-top: 10px;background:#00467f">Salva</button> -->
            <!-- <button class="btn float-right" type="button" v-on:click="salvaValoriDati()" style="margin-top: 10px;background:#00467f">Salva</button>
            <router-link :to="'valutazione-a?idCliente='+idCliente"><button class="btn float-right" type="button" style="margin-top: 10px;margin-right:20px;background:#00467f">Avanti</button></router-link>
            <router-link to="/clienti" class="btn float-right" style="margin-top: 10px;margin-right:10px;background:#00467f">Indietro</router-link> -->
            
    </div>
</template>
<script>
// import Card from "@/components/Cards/Card.vue";
import Services from '@/services/Services';

export default {
    components: {
        // Card
    },

    data() {
        return {
            ambientiLavoro: {},
            
            idCliente: null,
            idSoggetto: null,
        }
    },

    props: {
        ambientiLavoroValori: {
            type: Object,
            required: true
        }
    },
    computed: {},

    methods: {
        addAmbientiLavoroValori() {
            this.ambientiLavoro = Object.assign({}, this.ambientiLavoroValori);
        },

    },
    created() {
        this.addAmbientiLavoroValori();
    },
    
    // mounted() {
    //     this.main();
    // } 

};
</script>
<style scoped>
    .row-color:hover {
    background-color: #00467f53;
    }
    label {
        font-size: 16px;
    }

    .label-switch {
            position: relative;
        /* display: inline-block; */
        display: table-cell;
        padding-right: 10px;
        padding-left: 10px;
        font-size: 16px;
    }
    .switch {
        position: relative;
        /* display: inline-block; */
        display: table-cell;
        width: 55px;
        height: 34px;
    }

    .switch input { 
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

        .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 0px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }
    input:checked + .slider {
        background-color: #00467f;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #00467f;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }
    .slider.round:before {
        border-radius: 50%;
    }
</style>
